import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserOrganization, UserRole } from '../models/user.model';
import { AuthStore } from '../store/auth.store';

function isAssignedRole(role: UserRole | null | undefined): boolean {
  return role !== null && role !== undefined && role !== 'NOTASSIGNED';
}

function hasAssignedMembership(
  primaryRole: UserRole | null,
  organizations: UserOrganization[]
): boolean {
  return isAssignedRole(primaryRole) || organizations.some((organization) => isAssignedRole(organization.Role));
}

export const assignedUserGuard: CanActivateFn = () => {
  const auth = inject(AuthStore);
  const router = inject(Router);

  return auth.loadSession().pipe(
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        return router.createUrlTree(['/login']);
      }

      if (hasAssignedMembership(auth.currentUserRole(), auth.organizations())) {
        return true;
      }

      return router.createUrlTree(['/help'], {
        queryParams: { topic: 'account-access' },
      });
    })
  );
};
